export default {"src":"/_next/static/media/youtube.eaa3c4c8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};